import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';

export interface DialogData { object: any, formTitle: string, descriptionRequired?: boolean , addingNew: boolean;}

@Component({
    selector: 'simple-dialog-form',
    templateUrl: './simple-dialog-form.component.html',
    styleUrls: ['./simple-dialog-form.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class SimpleDialogFormComponent implements OnInit {

    data: DialogData;
    object: any;
    resultObjects:any[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) private _data: DialogData,
        public dialogRef: MatDialogRef<SimpleDialogFormComponent>) {
    }

    ngOnInit(): void {
        this.data = this._data;
        this.object = { ...this._data.object }; // copy object to not use refernce
    }

    onSubmit(form: NgForm, saveAndCreate?: boolean) {
        if (form.valid) {
            if (this.data.addingNew) {
                this.resultObjects.push(this.object);
                if (saveAndCreate) {
                    this.object = {};
                    form.reset();
                } else {
                    this.dialogRef.close(this.resultObjects);
                }
            } else {
                this.dialogRef.close(this.object);
            }
        } else {
            Object.keys(form.controls).forEach(field => {
                const control = form.controls[field];
                control.markAsTouched({ onlySelf: true });
            });
        }
    }

    closeDialog(){
        if(this.data.addingNew){
            this.dialogRef.close(this.resultObjects.length > 0 ? this.resultObjects : undefined);
        }else{
            this.dialogRef.close();
        }
    }

}
